//index.js
import DataIcon from './DataIcon/DataIcon';
import FarmIcon from './FarmIcon/FarmIcon';
import FinancesIcon from './FinancesIcon/FinancesIcon';
import GrantsIcon from './GrantsIcon/GrantsIcon';
import InsuranceIcon from './InsuranceIcon/InsuranceIcon';
import ShopIcon from './ShopIcon/ShopIcon';

export {
  DataIcon,
  FarmIcon,
  FinancesIcon,
  GrantsIcon,
  InsuranceIcon,
  ShopIcon,
};
